import React from 'react'
import { Link } from 'react-router-dom'

const Signup = () => {
    return (
        <div>
            <div className="row justify-content-center">
                {/* <!-- start: page body area --> */}
                <div className="col-md-4 p-4 auth-body border rounded">
                    <form>
                        <ul className="row g-3 list-unstyled li_animate">
                            <li className="col-6">
                                <label className="form-label">Full name</label>
                                <input type="text" className="form-control form-control-lg" placeholder="Jony" />
                            </li>
                            <li className="col-6">
                                <label className="form-label">&nbsp;</label>
                                <input type="text" className="form-control form-control-lg" placeholder="Parker" />
                            </li>
                            <li className="col-12">
                                <label className="form-label">Email address</label>
                                <input type="email" className="form-control form-control-lg"
                                    placeholder="name@gmail.com" />
                            </li>
                            <li className="col-6">
                                <label className="form-label">Password</label>
                                <input type="password" className="form-control form-control-lg"
                                    placeholder="8+ characters required" />
                            </li>
                            <li className="col-6">
                                <label className="form-label">Confirm password</label>
                                <input type="password" className="form-control form-control-lg"
                                    placeholder="8+ characters required" />
                            </li>
                            <li className="col-12">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" defaultValue="" id="TermsConditions" />
                                    <label className="form-check-label" htmlFor="TermsConditions" >
                                        I accept the
                                        <Link to="/" title="" className="text-primary">Terms and Conditions</Link>
                                    </label>
                                </div>
                            </li>
                            <li className="col-12 mt-4 mb-2">
                                <Link className="btn btn-lg w-100 btn-primary text-uppercase mb-2" to="/">SIGN
                                    UP</Link>
                            </li>
                            <li className="col-12 text-center">
                                <span className="text-muted d-flex d-sm-inline-flex mt-1 mt-sm-0">
                                    Already have an account?
                                    <Link className="ms-2" to="/signin">Sign in here</Link>
                                </span>
                            </li>
                        </ul>
                        {/* <!--[ ul.row end ]--> */}
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Signup